import { makeStyles } from 'tss-react/mui';
import { teceoPrimaryMain } from '../../../../Theme';

const useUpdateOrderModalStyles = makeStyles()({
  checkboxLine: {
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  selectedCheckboxLine: {
    backgroundColor: `${teceoPrimaryMain}0D`,
  },
});

export default useUpdateOrderModalStyles;
